"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var PaymentSchedule = /** @class */ (function (_super) {
    __extends(PaymentSchedule, _super);
    function PaymentSchedule(props) {
        var _this = _super.call(this, props) || this;
        _this.progressContainerRef = React.createRef();
        _this.lastDoneInstalmentDotRef = React.createRef();
        _this.renderHorizontalDots = function () {
            return _this.props.instalments.map(function (instalment, index) {
                var isDone = index <= _this.state.lastDoneInstalmentIndex;
                return ((0, jsx_runtime_1.jsx)("div", { className: "progress-dot".concat(isDone ? " progress-dot--paid" : ""), ref: index === _this.state.lastDoneInstalmentIndex ? _this.lastDoneInstalmentDotRef : undefined }, instalment.month));
            });
        };
        _this.renderVerticalDotsWithSchedule = function () {
            return _this.props.instalments.map(function (instalment, index, instalments) {
                var amount = instalment.principal + instalment.interest;
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__grid-item instalment-text-color", children: moment(instalment.dueDate).format("DD MMM YYYY") }), (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__grid-item", children: (0, jsx_runtime_1.jsx)("div", { className: "progress-dot", ref: index === _this.state.lastDoneInstalmentIndex ? _this.lastDoneInstalmentDotRef : undefined }) }), (0, jsx_runtime_1.jsxs)("div", { className: "payment-schedule__grid-item payment-plan-item instalment-text-color", children: ["\u00A3".concat(amount.toFixed(2)), " ", index === 0 ? "(1st pay)" : ""] })] }, instalment.month));
            });
        };
        _this.state = {
            lastDoneInstalmentIndex: -1
        };
        return _this;
    }
    PaymentSchedule.prototype.componentWillUnmount = function () {
        if (this.windowResizeEventSubscription) {
            this.windowResizeEventSubscription.unsubscribe();
        }
    };
    PaymentSchedule.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "payment-schedule ".concat(this.props.isOpen ? "payment-schedule--open" : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress-container", ref: this.progressContainerRef, children: (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress", children: (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__progress-bar" }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "payment-schedule__dot-container", children: this.props.isOpen ? this.renderVerticalDotsWithSchedule() : this.renderHorizontalDots() })] }));
    };
    return PaymentSchedule;
}(React.Component));
exports.default = PaymentSchedule;
//# sourceMappingURL=PaymentSchedule.js.map